import { render, staticRenderFns } from "./SelectComp.vue?vue&type=template&id=df113cb0&scoped=true"
import script from "./SelectComp.vue?vue&type=script&lang=js"
export * from "./SelectComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df113cb0",
  null
  
)

export default component.exports